import { styled, Typography, TypographyProps } from '@mui/material'

export const UICustomTypographyTitle = styled((p: TypographyProps) => <Typography variant='h6' component='h5' {...p} />)({
  textTransform: 'uppercase',
  color: 'var(--coclor-text)',
  textAlign: 'center',
  fontWeight: 600
})
